export default __webpack_public_path__ + "static/media/armwraps_of_the_doomsayer.33cfc3d9.jpg";